// src/pages/DashboardPage.tsx
import React from 'react';
import { Tabs } from 'antd';
import AttendanceSetting from './AttendanceSetting';
// import UserSetting from './UserSetting';
import { useTypedSelector } from "../store";
import { Navigate } from "react-router-dom";
import DepartmentSetting from './departments/DepartmentSetting';
import LevelSetting from './levels/LevelSetting';
import UserSetting from './users/UserSetting';
import ScheduleSetting from './schedules/ScheduleSetting';
import OrganisationSetting from './organisations/OrganisationSetting';

const { TabPane } = Tabs;


const SettingPage: React.FC = () => {
    const { authData, isLogin } = useTypedSelector((state) => {
        return {
          authData: state.Auth.loginData,
          isLogin: state.Auth.isLogin,
        };
      });
      console.log(authData, isLogin);
      
      if(!isLogin){
        return <Navigate to="/login" replace/>
      }
    return (
        <Tabs defaultActiveKey="1">
            <TabPane tab="User" key="1">
                <UserSetting />
            </TabPane>
            <TabPane tab="Attendance" key="2">
                <AttendanceSetting />
            </TabPane>
            <TabPane tab="Level" key="3">
                <LevelSetting/>
            </TabPane>
            <TabPane tab="Department" key="4">
                <DepartmentSetting/>
            </TabPane>
            <TabPane tab="Organisation" key="5">
                <OrganisationSetting/>
            </TabPane>
            <TabPane tab="Schedule" key="6">
                <ScheduleSetting/>
            </TabPane>
        </Tabs>
    )
}

export default SettingPage;
